<template>
  <div class="customers__all">
    <div class="w-full grid grid-flow-col grid-cols-7 items-center p-6">
      <h1 class="font-bold col-start-1 col-end-6">Customers</h1>
      <div></div>
      <router-link to="/customers/new" class="col-start-6 col-end-7">
        <a-button type="primary">Create User</a-button>
      </router-link>
      <a-button @click="download()" class="col-start-7 col-end-8">Download Users</a-button>
    </div>

    <Filters />

    <div class="customers__all__container">
      <Table :columns="columns" :data="users">
        <template v-slot:name="scope">
          <p>{{ `${scope.item.first_name} ${scope.item.last_name}` }}</p>
        </template>
        <template v-slot:subscription_plan_id="scope">
          <a-tag color="blue" v-if="scope.item.subscription_plan_id">
            {{
              scope.item.subscription_plan_id == "636842" ? "Annual" : "Monthly"
            }}
          </a-tag>
          <a-tag v-else-if="scope.item.checkout_id">
            Unlimited
          </a-tag>

          <a-tag v-else>
            No have plan
          </a-tag>
        </template>
        <template v-slot:role="scope">
          <p>{{ scope.item.role && scope.item.role.name }}</p>
        </template>
        <!-- <template v-slot:collections="scope">
          <a-tag
            color="blue"
            v-for="collection in scope.item.collections"
            :key="collection"
            @click="
              (modalIsVisible = true), (userCollection = scope.item.collections)
            "
          >
            {{ collection.title }}
          </a-tag>
        </template> -->
        <template v-slot:subscription_status="scope">
          <a-tag color="green" v-if="scope.item.subscription_status">
            ON
          </a-tag>
          <a-tag color="red" v-else>
            OFF
          </a-tag>
        </template>
        <template v-slot:cancellation_effective_date="scope">
          <p v-if="scope.item.cancellation_effective_date" :class="{
            soon: verifySoonCancellation(
              scope.item.cancellation_effective_date
            ),
            expired: verifyExpiredCancellation(
              scope.item.cancellation_effective_date
            ),
          }">
            No, {{ formatDate(scope.item.cancellation_effective_date) }}
          </p>
          <p v-else>Yes</p>
        </template>
        <template v-slot:last_login="scope">
          <p>{{ scope.item.last_login || "-" }}</p>
        </template>
        <template v-slot:actions="scope">
          <a-button @click="changeStatus(scope.item)" class="mr-2">Change Status</a-button>
          <a-button @click="giveFullAccess(scope.item)" v-if="scope.item.role.name !== 'lifetime'" class="mr-2">Give Full
            Access</a-button>
          <router-link :to="`/customers/edit/${scope.item.id}`">
            <a-button class="mr-2">Edit</a-button>
          </router-link>
          <!-- <router-link :to="`/customers/${scope.item.id}`">
            <a-button>Change Access</a-button>
          </router-link> -->

          <a-button @click="useIt(scope.item)" class="mr-2">Use it</a-button>
          <router-link :to="`/customers/${scope.item.id}`">
            <a-button>Show More</a-button>
          </router-link>
        </template>
      </Table>
    </div>
    <Modal v-model:isVisible="modalIsVisible" v-model:id="userCollection" />
  </div>
</template>

<script>
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import moment from "moment";
import Table from "@/components/Table/index";
import Modal from "@/components/Modals/ChangeCollection";
import Filters from "@/components/CustomerFilters";

export default {
  components: { Table, Modal, Filters },
  setup() {
    const store = useStore();
    const modalIsVisible = ref(false);
    const userCollection = "";
    onMounted(() => {
      store.dispatch("GET_USERS");
      store.dispatch("GET_USER_COUNT")
    });

    const columns = ref([
      {
        title: "Email",
        dataIndex: "email",
        key: "id",
        style: {
          width: "250px",
        },
      },
      {
        title: "Name",
        dataIndex: "name",
        key: "id",
        slot: true,
      },
      {
        title: "Plan",
        dataIndex: "subscription_plan_id",
        key: "id",
        slot: true,
      },
      {
        title: "Role",
        dataIndex: "role",
        key: "id",
        slot: true,
      },
      // {
      //   title: "Access to",
      //   dataIndex: "collections",
      //   key: "id",
      //   slot: true,
      //   style: {
      //     width: "350px",
      //   },
      // },
      {
        title: "Subscription Status",
        dataIndex: "subscription_status",
        key: "id",
        slot: true,
      },
      {
        title: "Keep?",
        dataIndex: "cancellation_effective_date",
        key: "id",
        slot: true,
      },
      {
        title: "Last login",
        dataIndex: "last_login",
        key: "id",
        slot: true,
      },
      {
        title: "Actions",
        dataIndex: "actions",
        key: "actions",
        slot: true,
        style: {
          width: "550px",
        },
      },
    ]);

    const users = computed(() => store.state.users);
    const verifySoonCancellation = (date) => {
      const cancellationDate = new Date(date);
      let today = new Date();
      today.setDate(today.getDate() + 7);

      if (cancellationDate < today) {
        return true;
      }
      return false;
    };

    const verifyExpiredCancellation = (date) => {
      const cancellationDate = new Date(date);
      let today = new Date();

      if (cancellationDate <= today) {
        return true;
      }
      return false;
    };

    const changeAccess = (item) => {
      console.log("cha", item);
    };

    // const changeCollection = (item) => {};

    const changeStatus = (item) => {
      store.dispatch("CHANGE_SUBSCRIPTION_STATUS", {
        id: item.id,
        subscription_status: !item.subscription_status,
      });
    };
    const giveFullAccess = (item) => {
      store.dispatch("GIVE_FULL_ACCESS", {
        id: item.id,
      });
    };

    const download = async () => {
      const datas = await store.dispatch("DOWNLOAD_USERS");
      var fileURL = window.URL.createObjectURL(
        new Blob([datas.data.data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
      );
      var fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute(
        "download",
        `users-${new Date().toLocaleString()}.xlsx`
      );
      document.body.appendChild(fileLink);
      fileLink.click();
    };

    const useIt = (item) => {
      store.dispatch("SIGN_IN_WITHOUT_PASSWORD", {
        email: item.email,
      });
    };

    const formatDate = (value) => {
      return moment(value).format("D MMMM YYYY");
    };

    return {
      columns,
      users,
      verifySoonCancellation,
      verifyExpiredCancellation,
      changeStatus,
      giveFullAccess,
      download,
      useIt,
      formatDate,
      changeAccess,
      modalIsVisible,
      userCollection,
    };
  },
};
</script>

<style scoped>
.customers__all {
  max-width: calc(100vw - 200px);
  margin: 0 auto;
  height: 100vh;
  display: grid;
  grid-template-rows: auto 1fr;
}

.customers__all__header {
  height: 80px;
  display: flex;
  align-items: center;
  padding: 0 20px;
}

.customers__all__container {
  max-width: calc(100vw - 200px);
  height: calc(100vh - 80px);
}

.soon {
  @apply bg-yellow-500 text-white px-2;
}

.expired {
  @apply bg-red-500 text-white px-2;
}
</style>
